// src/components/checagens/TimelineEventos.tsx
import React, { useState, useEffect } from 'react';
import ConfirmDialog from '../ConfirmDialog'; // Import the modal
import { useEventosImovel, useMarcarCaptacao } from '../../hooks/useChecagens';
import { formatToSaoPaulo } from '../../utils/dates';
import { EventoImovel } from '../../models/checagens';
import { Mail, MessageCircle, Phone, Calendar, BadgeCheck, StickyNote } from 'lucide-react';
import './TimelineEventos.css';

import { CAPTACAO_STATUS, CaptacaoStatus } from '../../utils/checagens';

const SELECTABLE_CAPTACAO_STATUS = {
  captado_exclusivo: 'Captado (Exclusivo)',
  captado_nao_exclusivo: 'Captado (Não Exclusivo)',
  sem_interesse: 'Sem Interesse',
  locacao: 'Locação',
};

interface TimelineEventosProps {
  imovelId: number;
  checagemImovelId: number;
  resultadoCaptacao?: CaptacaoStatus | null;
}

const EVENT_ICONS: { [key: string]: React.ReactNode } = {
  contato_email: <Mail size={16} />,
  contato_whatsapp: <MessageCircle size={16} />,
  ligacao: <Phone size={16} />,
  agendamento: <Calendar size={16} />,
  captacao_realizada: <BadgeCheck size={16} />,
  nota: <StickyNote size={16} />,
};

const TimelineEventos: React.FC<TimelineEventosProps> = ({ imovelId, checagemImovelId, resultadoCaptacao }) => {
  const { data: eventos, isLoading } = useEventosImovel(imovelId);
  const marcarCaptacaoMutation = useMarcarCaptacao();
  const [isModalOpen, setModalOpen] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState<CaptacaoStatus>('captado_exclusivo');

  useEffect(() => {
    if (resultadoCaptacao && CAPTACAO_STATUS[resultadoCaptacao]) {
      setSelectedStatus(resultadoCaptacao);
    }
  }, [resultadoCaptacao]);

  const handleMarcarCaptacao = () => {
    setModalOpen(true);
  };

  const confirmCaptacao = () => {
    marcarCaptacaoMutation.mutate({ ciId: checagemImovelId, resultado: selectedStatus });
    setModalOpen(false);
  };

  return (
    <div className="card timeline-card">
      <h3>Timeline de Eventos</h3>
      <div className="captacao-actions">
        <select 
          value={selectedStatus} 
          onChange={(e) => setSelectedStatus(e.target.value as CaptacaoStatus)}
        >
          {Object.entries(SELECTABLE_CAPTACAO_STATUS).map(([value, label]) => (
            <option key={value} value={value}>{label}</option>
          ))}
        </select>
        <button onClick={handleMarcarCaptacao}>Marcar Captação</button>
      </div>
      <div className="timeline-content">
        {isLoading && <p>Carregando eventos...</p>}
        {eventos?.map((evento: EventoImovel) => (
          <div key={evento.id} className="timeline-item">
            <div className="timeline-icon">{EVENT_ICONS[evento.tipo_evento] || <StickyNote size={16} />}</div>
            <div className="timeline-body">
              <p className="timeline-detail">{evento.detalhe_evento}</p>
              <span className="timeline-meta">
                {evento.usuario_cadastro} - {formatToSaoPaulo(evento.data_evento)}
              </span>
            </div>
          </div>
        ))}
        {eventos?.length === 0 && !isLoading && <p>Nenhum evento registrado.</p>}
      </div>
      {isModalOpen && (
        <ConfirmDialog 
          message={`Confirmar a captação deste imóvel como "${CAPTACAO_STATUS[selectedStatus]}"?`}
          onConfirm={confirmCaptacao}
          onCancel={() => setModalOpen(false)}
        />
      )}
    </div>
  );
};

export default TimelineEventos;